
<template>
    <div>
        <q-card class="text-caption">
            <q-card-section>
                <div>FATCA INFORMATION</div>
            </q-card-section>
            <q-separator/>
            <q-card-section>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Tax Residency
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.FATCAInformation.TaxResidency}}
                    </div>
                </div>
                <div>
                    TIN Information
                </div>
                <div v-for="tininfo in StoreStateAOD.FATCAInformation.TINInformation" v-bind:key="tininfo.index">
                    <div class="row q-pb-sm">
                        <div class="col-4">
                            Country
                        </div>
                        <div class="col">
                            : {{tininfo.TINCountry}}
                        </div>
                    </div>
                    <div class="row q-pb-sm">
                        <div class="col-4">
                            No
                        </div>
                        <div class="col">
                            : {{tininfo.TINNo}}
                        </div>
                    </div>
                    <div class="row q-pb-sm">
                        <div class="col-4">
                            Unavailable Reason
                        </div>
                        <div class="col">
                            : {{tininfo.TINReason}}
                        </div>
                     </div>   
                    <div class="row q-pb-sm">
                        <div class="col-4">
                            Reason B Explanation
                        </div>
                        <div class="col">
                            : {{tininfo.TINReasonB}}
                        </div>
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Us Resident
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.FATCAInformation.USResident}}
                    </div>
                </div>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Type Of US Resident
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.FATCAInformation.USResidentIndicia}}
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'SummaryFATCAInformation',
    data() {
        return {
            StoreStateAOD : store.state.AOD
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>